import requestStuff from './requestStuff'
import requestStuffResult from './requestStuffResult'


export default [
  ...requestStuff,
  ...requestStuffResult
]
